'use client';

import { cn } from '@/lib/utils';
import { FileCheck, X } from 'lucide-react';

export default function FilePreview({
    fileName,
    onRemove = () => {},
    className,
}: {
    fileName: string;
    className?: string;
    onRemove?: () => void;
}) {
    return (
        <div
            className={cn(
                'bg-white border border-brand rounded-30 py-2 px-4 relative max-lg:py-1 max-lg:px-2 h-12 max-sm:h-10 flex justify-center items-center',
                className,
            )}
        >
            <span className="text-p font-normal underline text-brand cursor-pointer flex items-center text-nowrap">
                {fileName}
                <FileCheck className="ml-2" width={18} height={18} />
                <X
                    width={12}
                    height={12}
                    className="ml-2 opacity-80 text-dark-grey cursor-pointer"
                    onClick={onRemove}
                />
            </span>
        </div>
    );
}
